/**
 * Gated Site Modal
 *
 */

(function (window, document, $, undefined) {
	'use strict';

	window.siteGate = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			siteGate.initVars();
			siteGate.modal();
		},

		/**
		 * Setting and initializing all variables.
		 * @since 1.0.0
		 */
		initVars: function () {
			siteGate.$cookieName    = 'site_gate_cookie';
			siteGate.$site          = global_data_layer.site.replace( /\/+$/, "" );
			siteGate.$modalTitle    = deepObject( localized, 'site_gate_modal.title' );
			siteGate.$modalContent  = deepObject( localized, 'site_gate_modal.content' );
			siteGate.$modalAgree    = deepObject( localized, 'site_gate_modal.agree' );
			siteGate.$modalDisagree = deepObject( localized, 'site_gate_modal.disagree' );
			siteGate.$expiration    = deepObject( localized, 'site_gate_modal.expiration' );
			siteGate.$modalFooter   = '';
			siteGate.$siteCode      = $( 'body' ).data( 'site-code' );
		},

		/**
		 * Initialize the modal if required by CMS and not accepted by user yet
		 * @since 1.0.0
		 */
		modal: function () {
			// Don't load the modal on Smartling "source" sites because it screws up the CAT translation tool.
			if (window.location.href.indexOf("-source/") === -1 &&
			!Cookies.get(siteGate.$cookieName, { path: siteGate.$site }) &&
			siteGate.$modalTitle &&
			siteGate.$modalContent) {

				$(document).ready(function(){
					var ingestClass = $('body[class*=jh_ingest-template]');
					// Don't show on ingest posts
					if ( ingestClass.length === 0 ) {
						siteGate.$modalFooter +=
							'<div class="site-gating-modal-acceptance">' +
							'<span class="jh-btn ghost with-icon icon-r icon-arrow" onClick="window.modal.close()" tabindex="0">' + siteGate.$modalDisagree + '</span>' +
							'<span class="jh-btn primary with-icon icon-r icon-arrow js-accept-site-gate-terms" onClick="window.siteGate.accept()" tabindex="0">' + siteGate.$modalAgree + '</span>' +
							'</div>';

						window.modal.dynamic_open(
							siteGate.$modalTitle,
							siteGate.$modalContent,
							false,
							false,
							siteGate.$modalFooter
						);

						window.modal.onBeforeClose(siteGate.checkCookieAcceptance);
					}
				});
			}
		},

		/**
		 * Gated Site Cookie Acceptance Check
		 * If the user does not have acceptance cookie, then show the country select
		 * modal and apply a class to the body that hides the close button to force
		 * either selecting a country or navigating away from the site
		 * @since 1.0.0
		 */
		checkCookieAcceptance: function () {
			if ( ! Cookies.get( siteGate.$cookieName ) ) {
				// window.location.href = localized.home_base_url;

				var body      = document.getElementsByTagName( 'body' )[0];
				var gateModal = document.querySelector( '#js-modal' );
				// add .no-close-country-selector class to body to force a selection,
				// refresh, or site exit
				body.classList.add( 'no-close-country-selector' );

				// remove gated content modal
				gateModal.parentNode.removeChild( gateModal );

				// show country selector
				document.querySelector( '#menu-jh-masthead .menu-channel button' ).click();
				return false;
			}
		},

		/**
		 * Gated Site Acceptance
		 * When the user accepts the terms, set a cookie
		 * @since 1.0.0
		 */
		accept: function () {
			var cookieArgs = {
				expires: siteGate.$expiration,
				path: siteGate.$site,
			};

			if ( 'LOCAL' !== localized.gwp_environment ) {
				cookieArgs.secure   = true;
				cookieArgs.sameSite = 'None'
			}

			Cookies.set( siteGate.$cookieName, true , cookieArgs );
			window.modal.close();

			// Redirect to a Pardot URL on copa for tracking purposes.
			if ( 'copa' === siteGate.$siteCode) {
				window.location.href = "https://go.janushenderson.com/en-co/advisor";
			}
		},

		forceClose: function() {
			window.modal.close();
		}

	};
	siteGate.init();
})( window, document, jQuery );
